export { default, AnimatedNumber } from './AnimatedNumber';
